import { ShortcutsConfigProps } from './types';

export const INITIAL_SHORTCUTS_CONFIG: ShortcutsConfigProps = {};

export enum KEY_CODES {
  MetaKey = 'metaKey',
  KeyB = 'KeyB',
}
